import { render, staticRenderFns } from "./CapitalShiftToHistoryDetail.vue?vue&type=template&id=706bd2b6&scoped=true&"
import script from "./CapitalShiftToHistoryDetail.vue?vue&type=script&lang=ts&"
export * from "./CapitalShiftToHistoryDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CapitalShiftToHistoryDetail.vue?vue&type=style&index=0&id=706bd2b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706bd2b6",
  null
  
)

export default component.exports